import { IDecideNextStep } from "../../services/wizard/next-step-decider/next-step-decider.interface";
import { SelectOriginatorStepComponent } from "../../wizard/wizard-steps/select-originator-step/select-originator-step.component";
import { WizardStepBase } from "./wizard-step-base.model";

export class SelectOriginatorStep extends WizardStepBase {
  constructor(id: string, name: string, path: string, nextStepDecider?: IDecideNextStep) {
    super(id, name, path, nextStepDecider);
    this.component = SelectOriginatorStepComponent;
  }
}
